import type { Role } from '@testpio/shared';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { homePathFor, lastInstitute, useMe, usePlatformMe } from '../lib/auth';
import { ErrorState, FullPageLoader } from './common';

/** Shows children only to signed-in institute users with one of the roles; otherwise redirects. */
export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <FullPageLoader />;
  if (me.isError) return <ErrorState error={me.error} onRetry={() => void me.refetch()} />;
  if (!me.data) {
    const code = lastInstitute();
    return <Navigate to={code ? `/i/${code}` : '/'} replace state={{ from: location.pathname }} />;
  }
  if (!roles.includes(me.data.user.role)) return <Navigate to={homePathFor(me.data.user.role)} replace />;
  return <>{children}</>;
}

export function RequirePlatform({ children }: { children: ReactNode }) {
  const me = usePlatformMe();
  if (me.isPending) return <FullPageLoader />;
  if (me.isError) return <ErrorState error={me.error} onRetry={() => void me.refetch()} />;
  if (!me.data) return <Navigate to="/platform/login" replace />;
  return <>{children}</>;
}
